import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PUBLIC_API_ENDPOINT } from '../../constants/platform';

/**
 * Trang chuyển tiếp cho link tiếp thị: cab.vn/go/{code}
 *
 * Trước đây link chia sẻ trỏ THẲNG vào tên miền API kèm GUID
 * (api.beta.cab.vn/v1/payment-service/public/affiliate/go/{guid}) — vừa dài, vừa lộ
 * đường dẫn nội bộ, người dùng không dám đăng lên mạng xã hội.
 *
 * Nay link mang tên miền cab.vn. Trang này chỉ chuyển hướng sang endpoint đếm click,
 * endpoint đó ghi nhận click rồi 302 tiếp sang sản phẩm thật.
 * Dùng replace() để người dùng bấm Quay lại không rơi ngược vào trang trung gian.
 */
const AffiliateGoPage = () => {
  const { code } = useParams<{ code: string }>();

  useEffect(() => {
    if (!code) return;
    window.location.replace(
      `${PUBLIC_API_ENDPOINT}/v1/payment-service/public/affiliate/s/${encodeURIComponent(code)}`
    );
  }, [code]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <p className="text-sm text-gray-500 dark:text-gray-400">Đang chuyển hướng…</p>
    </div>
  );
};

export default AffiliateGoPage;
